// extracted by mini-css-extract-plugin
export default {"container":"YK-z","title":"ZK-z","link":"_K-z"};